import React from "react";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepConfirmationReadingLevel from "components/Step/StepConfirmationReadingLevel";
import { useDefaultFunnelPlan } from "utils/hooks/useDefaultFunnelPlan";
import { getSelectedPlan } from "components/PlanSelection/planSelectionUtil";
import { FEATURE_FLAG_SHOW_FALL25_COUPON } from "components/Membership/membershipFeatureFlags";

export const MembershipStepConfirmationReadingLevel = ({
  onStateUpdate,
  routePrevStep,
  routeNextStep,
  plans,
  plansPrepaid,
  ...state
}: MembershipState) => {
  const { setPlan } = useDefaultFunnelPlan();

  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  const nextButtonProps = {
    onClick: async () => {
      const selectedPlanSlug = await setPlan();
      const selectedPlan = getSelectedPlan({
        plans,
        plansPrepaid,
        selectedPlanSlug,
      });
      onStateUpdate?.({ selectedPlan });
      routeNextStep?.();
    },
  };

  return (
    <StepConfirmationReadingLevel
      {...state}
      stepFooterProps={{
        backButtonProps,
        nextButtonProps,
      }}
      stepHeaderProps={{ backButtonProps }}
      showFall25Coupon={FEATURE_FLAG_SHOW_FALL25_COUPON}
    />
  );
};

export const MEMBERSHIP_STEP_CONFIRMATION_READING_LEVEL: MembershipStep = {
  component: MembershipStepConfirmationReadingLevel,
  id: "membership-id-confirmation-reading-level",
  slug: "reading-level-recommendation",
};

export default MEMBERSHIP_STEP_CONFIRMATION_READING_LEVEL;
